import { render, staticRenderFns } from "./AuthenticationView.vue?vue&type=template&id=21a183cb&scoped=true"
import script from "./AuthenticationView.vue?vue&type=script&lang=ts"
export * from "./AuthenticationView.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationView.vue?vue&type=style&index=0&id=21a183cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a183cb",
  null
  
)

export default component.exports